import {
  applyServicosQuickFilters as applyBase,
  EMPTY_SERVICOS_QUICK_FILTER as EMPTY_BASE,
  isServicosFilterActive as isBaseActive,
} from '../../utils/servicosFilters';
import { getIntegracaoStatus } from './integracaoStatus';
import { rowIsMine } from './computeResumoNsir';

export const MTBT_STATUS_CHIPS = {
  ERRO_INTEGRACAO: 'erroIntegracao',
  DIGITADOS_POR_MIM: 'digitadosPorMim',
};

export const EMPTY_MTBT_QUICK_FILTER = {
  ...EMPTY_BASE,
  mtbtChip: null,
};

export const isMtBtFilterActive = (quickFilter) =>
  isBaseActive(quickFilter) || Boolean(quickFilter?.mtbtChip);

export const applyMtBtQuickFilters = (rows, quickFilter, { userId } = {}) => {
  let filtered = applyBase(rows, quickFilter);
  const chip = quickFilter?.mtbtChip;
  if (!chip) return filtered;

  if (chip === MTBT_STATUS_CHIPS.ERRO_INTEGRACAO) {
    return filtered.filter((row) => getIntegracaoStatus(row) === 'ERROR_SYNC');
  }
  if (chip === MTBT_STATUS_CHIPS.DIGITADOS_POR_MIM) {
    return filtered.filter((row) => rowIsMine(row, userId));
  }
  return filtered;
};

export default applyMtBtQuickFilters;
